import { AppRouteProps } from "@bsm/component";
import { AuthRoutes } from "@bsm/login";
import { UserDetailsRoutes, UserManagementRoutes } from "@bsm/user-management";
import { ProjectRoutes } from "@bsm/project";
import AdminLayout from "components/layout/AdminLayout";
import AuthLayout from "components/layout/AuthLayout";
import ClientLayout from "components/layout/ClientLayout";
import OrganisationAccessLayer from "container/OrganisationAccessLayer";
import HareaContainer from "container/HareaContainer";
import { UserAuthRoutesTest } from "./auth/UserAuthRoutes";
import { HomeRoutes } from "./home/HomeRoutes";
// import { ContractRoutes } from "@bsm/contract";
// import { PayslipRoutes } from "@bsm/payslip";
import { NotificationRoutes } from "@bsm/notification";
import { TranslationRoutes } from '@bsm/translation'
import { StaticPageRoutes } from "@bsm/static-page";
// import NotFound from "../components/NotFound";
import { DataExports } from "./data/DataRoutes";
// import {PublicStaticPageContainer} from "@bsm/static-page";

export const HareaRoutes: Array<AppRouteProps> = [
    {
        path: ":lang",
        title: `std_home`,
        element: <HareaContainer />,
        children: [
            {
                path: "",
                element: <OrganisationAccessLayer />,
                children: [
                    {
                        path: "admin",
                        element: <AdminLayout />,
                        children: [
                            ...HomeRoutes,
                            ...ProjectRoutes,
                            // ...ContractRoutes,
                            ...NotificationRoutes,
                            ...UserManagementRoutes,
                            ...StaticPageRoutes,
                            ...TranslationRoutes,
                            ...DataExports
                        ],
                    },
                ],
            },
            {
                path: "",
                element: <AuthLayout />,
                children: [
                    ...UserAuthRoutesTest,
                    ...AuthRoutes.filter((item) => item.path === "logout"),
                ],
            },
        ],
    },
];
